/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Family_XmlrpcInputs */

const cs_portals_family_xmlrpc = /** @type {(inputs: Portals_Family_XmlrpcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML-RPC jako Sreality`)
};

const en_portals_family_xmlrpc = /** @type {(inputs: Portals_Family_XmlrpcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML-RPC like Sreality`)
};

/**
* | output |
* | --- |
* | "XML-RPC like Sreality" |
*
* @param {Portals_Family_XmlrpcInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_family_xmlrpc = /** @type {((inputs?: Portals_Family_XmlrpcInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Family_XmlrpcInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_family_xmlrpc(inputs)
	return cs_portals_family_xmlrpc(inputs)
});